/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ElectronicDeviceType {
    Other = 'Other',
    Smartphone = 'Smartphone',
    Laptop = 'Laptop',
    Tablet = 'Tablet',
    Tv = 'Tv',
    Camera = 'Camera'
  }

    export const ElectronicDeviceTypeTranslocoMap: Record<ElectronicDeviceType, string> = {
    [ElectronicDeviceType.Other]: 'electronicDeviceType.other',
    [ElectronicDeviceType.Smartphone]: 'electronicDeviceType.smartphone',
    [ElectronicDeviceType.Laptop]: 'electronicDeviceType.laptop',
    [ElectronicDeviceType.Tablet]: 'electronicDeviceType.tablet',
    [ElectronicDeviceType.Tv]: 'electronicDeviceType.tv',
    [ElectronicDeviceType.Camera]: 'electronicDeviceType.camera',
    };

    export const ElectronicDeviceTypeOptions = [
  { value: ElectronicDeviceType.Other, labelKey: 'electronicDeviceType.other' },
  { value: ElectronicDeviceType.Smartphone, labelKey: 'electronicDeviceType.smartphone' },
  { value: ElectronicDeviceType.Laptop, labelKey: 'electronicDeviceType.laptop' },
  { value: ElectronicDeviceType.Tablet, labelKey: 'electronicDeviceType.tablet' },
  { value: ElectronicDeviceType.Tv, labelKey: 'electronicDeviceType.tv' },
  { value: ElectronicDeviceType.Camera, labelKey: 'electronicDeviceType.camera' },
    ];

